import { Spinner as SpinnerChakra, Box } from '@chakra-ui/react';

export default function SpinnerComponent() {
  <Box display="flex" justifyContent="center" alignItems="center" alignContent="center">
    <SpinnerChakra />
  </Box>;
}
